/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_TitleInputs */

const nl_help_title = /** @type {(inputs: Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vragen en suggesties`)
};

/**

* @param {Help_TitleInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const help_title = /** @type {((inputs?: Help_TitleInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_TitleInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_help_title(inputs)
});
export { help_title as "help.title" }